import 'bootstrap';
import 'jquery-ui-bundle';
import 'webpack-jquery-ui/selectmenu';
import 'webpack-jquery-ui/autocomplete';
import 'webpack-jquery-ui/css';
import 'jquery-ellipsis';
import 'jquery-validation';

// Utilities
import buttons from './utilities/buttons';
import forms from './utilities/forms';
import validation from './utilities/validation';
import modal from './utilities/modal';

// Components
import header from './components/header';
import headersearch from './components/headersearch';
import customTable from './components/customTable';
import { logoutHandler } from './components/logout';
import linkAccountModal from './components/linkAccountModal';
import { setupAnalytics } from './components/analytics/default';
import { loginPageEventHandler } from './components/login';

// Initialisations
setupAnalytics();
logoutHandler();
loginPageEventHandler();

// Utilities
buttons();
forms();
validation();
modal();

// Components
header();
headersearch();
customTable();
linkAccountModal();
